module.exports = __webpack_public_path__ + "img/nature3.9dbd6676.jpg";